import './recovery-tab.scss';

import {
  CreateRecoveryField,
  getCreateRecoveryFieldProps,
} from '@converge/data';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import {
  NewConvergeButton,
  NewFormTextField,
  NewTypeAhead,
} from '../../../../presentation';
import React, { useCallback, useMemo } from 'react';

import AddAlertOutlinedIcon from '@mui/icons-material/AddAlertOutlined';
// import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box, Typography } from '@mui/material';

interface RecoveryTabProps {
  mockRecoveryData: unknown[];
  formatDollarAmount: (amount: number) => string;
}
const RECOVERY_TYPE_OPTIONS = [
  { label: 'ALAE', value: 'alae' },
  { label: 'LOSS', value: 'loss' },
  { label: 'ULAE', value: 'ulae' },
];

export const RecoveryTab: React.FC<RecoveryTabProps> = () => {
  // const [recoveryRows, setRecoveryRows] = React.useState([0]);

  // const handleAddRecovery = () => {
  //   setRecoveryRows([...recoveryRows, recoveryRows.length]);
  // };

  // const handleRemoveRecovery = (idToRemove: number) => {
  //   // Only remove the row if there's more than one row
  //   if (recoveryRows.length > 1) {
  //     setRecoveryRows(recoveryRows.filter((id) => id !== idToRemove));
  //   }
  //   // If it's the last row, do nothing to preserve at least one row
  // };

  return (
    <>
      {/* {recoveryRows.map((rowId, index) => (
        <RecoveryRow
          key={rowId}
          id={rowId}
          isFirst={index === 0}
          isLast={index === recoveryRows.length - 1}
          onRemove={() => handleRemoveRecovery(rowId)}
        />
      ))}

      <Grid item xs={12}>
        <Button
          style={{
            border: 'none',
            color: 'black',
            marginLeft: '10px',
            backgroundColor: 'transparent',
            fontWeight: ' 600 !important',
            marginTop: recoveryRows.length === 0 ? '55px' : '0',
          }}
          variant="outlined"
          startIcon={<AddCircleOutlineOutlinedIcon />}
          className="recovery-button--add"
          onClick={handleAddRecovery}
          disableRipple
        >
          ADD ANOTHER RECOVERY
        </Button>
      </Grid> */}
      <Typography
        variant="body1"
        sx={{
          textAlign: 'center',
          marginTop: '13%',
          fontSize: '34px',
          fontWeight: '400px',
        }}
      >
        UNDER DEVELOPMENT
      </Typography>
    </>
  );
};

interface RecoveryRowProps {
  id: number;
  isFirst: boolean;
  isLast: boolean;
  onRemove: () => void;
}

export const RecoveryRow: React.FC<RecoveryRowProps> = ({
  id,
  isFirst,
  isLast,
  onRemove,
}) => {
  // We use id as a key in the parent component and potentially could use it for form field names
  const formId = `recovery-${id}`;
  const isPaid = false;
  interface CreateRecoveryFields {
    [CreateRecoveryField.RecoveryType]: string;
    [CreateRecoveryField.AmountAnticipated]: string;
  }

  const formMethods = useForm<CreateRecoveryFields>({
    defaultValues: {},
    mode: 'onChange',
  });

  // Watch both fields to check if they have values
  const recoveryType = formMethods.watch(CreateRecoveryField.RecoveryType);
  const amountAnticipated = formMethods.watch(
    CreateRecoveryField.AmountAnticipated
  );

  // Check if both fields have values
  const isButtonDisabled = useMemo(() => {
    return !recoveryType || !amountAnticipated;
  }, [recoveryType, amountAnticipated]);

  const SubmitRecoveryHandler = useCallback(
    (): SubmitHandler<CreateRecoveryFields> => async () => {
      // Handle form submission here
    },
    []
  );

  return (
    <FormProvider {...formMethods}>
      <Box
        sx={{ width: '91.5%', marginLeft: '25px' }}
        className="recovery-tab"
        id={formId}
      >
        <Box
          className={`recovery-form ${
            isFirst ? 'recovery-form--is-first' : ''
          } ${isLast ? 'recovery-form--is-last' : ''}`}
          sx={{ display: 'flex', marginTop: isFirst ? '40px' : '0px' }}
        >
          <Box className="recovery-form__field recovery-form__field--standard">
            <Box sx={{ display: 'flex' }}>
              <Box
                sx={{
                  mr: 2,
                  display: 'flex',
                  alignItems: 'center',
                  paddingTop: '26px',
                }}
              >
                <AddAlertOutlinedIcon className="recovery-icon" />
              </Box>
              <Box sx={{ flexGrow: 1 }} className="recovery-select__container">
                {' '}
                <NewTypeAhead
                  options={RECOVERY_TYPE_OPTIONS}
                  placeholder="Select Recovery Type"
                  {...getCreateRecoveryFieldProps(
                    CreateRecoveryField.RecoveryType
                  )}
                  dataTestId="recovery-type"
                />
              </Box>
            </Box>
          </Box>

          <Box className="recovery-form__field recovery-form__field--standard">
            <NewFormTextField
              fullWidth
              {...getCreateRecoveryFieldProps(
                CreateRecoveryField.AmountAnticipated
              )}
              label={'AMOUNT ANTICIPATED'}
              data-testid="amount-anticipated"
              placeholder="$ 0"
              variant="outlined"
              autoComplete={false}
              isNumber={true}
            />
          </Box>

          <Box className="recovery-form__field recovery-form__field--narrow">
            <Box className="recovery-text__label">AMOUNT RECEIVED</Box>
            <Box
              className={`recovery-text__value ${
                isPaid ? '' : 'recovery-text__value--inactive'
              }`}
            >
              $ 0
            </Box>
          </Box>

          <Box className="recovery-form__field recovery-form__field--narrow">
            <Box className="recovery-text__label">DATE RECEIVED</Box>
            <Box
              className={`recovery-text__value ${
                isPaid ? '' : 'recovery-text__value--inactive'
              }`}
            >
              MM/DD/YYYY
            </Box>
          </Box>

          <Box className="recovery-form__field recovery-form__field--action">
            {isPaid ? (
              <Box className="recovery-status--paid">PAID</Box>
            ) : (
              <NewConvergeButton
                label={'Save'}
                disabled={isButtonDisabled}
                onClick={formMethods.handleSubmit(SubmitRecoveryHandler())}
              />
            )}
          </Box>

          <Box className="recovery-form__field recovery-form__field--close">
            <CancelOutlinedIcon onClick={onRemove} />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};
